import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { ApiError, AuthService, ButtonLoader, MessageService } from '../../../../core';
import { UsuarioPerfil } from '../../../usuario';
import { Campanha, createSemCampanha } from '../campanha';
import { CampanhaFilter } from '../filter';
import { CampanhaPedidoLiberarComponent } from '../pedidos/liberar';
import { CampanhaResultadoHttpService } from '../resultado';
import { CampanhaAuthGuardService, CampanhaCrudHttpService } from '../services';
import { isStatusEmAnalise, isStatusEmAndamento, isStatusEmRevisao, isStatusEncerrada, isStatusNaoConfirmada, isStatusReprovada } from '../status';
import { CampanhaResultadoViewComponent } from '../resultado/view';
import { ArquivoReferencia, arquivoReferenciaCampanha } from '../../../arquivos/referencias';
import { ArquivoCardViewComponent } from '../../../arquivos/arquivos/components/card-view';

interface Config {
    isNaoConfirmada: boolean;
    isEmAnalise: boolean;
    isEmAnaliseSearch: boolean;
    isEmAndamento: boolean;
    isEmRevisao: boolean;
    isEncerrada: boolean;
    isReprovada: boolean;
    isSemCampanha: boolean;
    possuiPedidoVendasNaoLiberados: boolean;
    possuiPedidosBonificacoesNaoLiberados: boolean;
    isLiberandoPedidos: boolean;
    isShowTabRepresentante: boolean;
    referenciaArquivos: ArquivoReferencia;
}


@Component({
    selector: 'sgt-campanha-visualizar-modal',
    templateUrl: './campanha-visualizar-modal.component.html',
    styleUrls: ['./campanha-visualizar-modal.component.less']
})
export class CampanhaVisualizarModalComponent {
    config: Config;
    perfilUsuario: UsuarioPerfil;

    elModal: any;
    editMode: boolean;
    campanha: Campanha;
    statusCampanha: number;
    isLoading: boolean;
    filter: CampanhaFilter;


    @Output() afterLiberarPedidos = new EventEmitter<void>();

    @ViewChild('pedidosLiberar') pedidosLiberar: CampanhaPedidoLiberarComponent;
    @ViewChild('resultadoView') resultadoView: CampanhaResultadoViewComponent;
    @ViewChild('arquivosCardView') arquivosCardView: ArquivoCardViewComponent;

    constructor(private el: ElementRef,
                private authService: AuthService,
                private messageService: MessageService,
                private campanhaAuthGuardService: CampanhaAuthGuardService,
                private campanhaCrudHttpService: CampanhaCrudHttpService,
                private campanhaResultadoHttpService: CampanhaResultadoHttpService) { }

    ngOnInit() {
        this.perfilUsuario = this.authService.getPerfilUsuario();

        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    private setConfig() {
        if (!this.campanha) {
            return;
        }
        this.config = {
            isNaoConfirmada: isStatusNaoConfirmada(this.campanha.status),
            isEmAnalise: isStatusEmAnalise(this.campanha.status),
            isEmAnaliseSearch: false,
            isEmAndamento: isStatusEmAndamento(this.campanha.status),
            isEmRevisao: isStatusEmRevisao(this.campanha.status),
            isEncerrada: isStatusEncerrada(this.campanha.status),
            isReprovada: isStatusReprovada(this.campanha.status),
            isSemCampanha: this.campanha.id === -1,
            possuiPedidoVendasNaoLiberados: false,
            possuiPedidosBonificacoesNaoLiberados: false,
            isLiberandoPedidos: false,
            isShowTabRepresentante: this.campanhaAuthGuardService.canShowRepresentante(),
            referenciaArquivos: arquivoReferenciaCampanha
        };
    }

    private setConfigAfterLoad(liberarPedidos: boolean) {
        if (!this.campanha) {
            return;
        }
        this.setConfig();
        this.config.isEmAnaliseSearch = isStatusEmAnalise(this.statusCampanha);
        this.config.possuiPedidoVendasNaoLiberados = this.campanha.resultado?.quantidadePedidosVendasNaoLiberados > 0;
        this.config.possuiPedidosBonificacoesNaoLiberados = this.campanha.resultado?.quantidadePedidosBonificacoesNaoLiberados > 0;
        this.config.isLiberandoPedidos = this.config.isEmAnaliseSearch && liberarPedidos && (this.config.possuiPedidoVendasNaoLiberados || this.config.possuiPedidosBonificacoesNaoLiberados);

    }

    /** Abre o modal */
    open(idCampanha: number, filter: CampanhaFilter, statusCampanha: number = null, liberarPedidos = false) {
        this.filter = filter;

        if (idCampanha > 0) {
            this.load(idCampanha, filter, statusCampanha, liberarPedidos);
        } else {
            this.loadSemCampanha();
        }

        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    private load(idCampanha: number, filter: CampanhaFilter, statusCampanhaSearch: number, liberarPedidos: boolean) {
        this.isLoading = true;
        this.campanhaCrudHttpService.load(idCampanha, filter, statusCampanhaSearch)
            .subscribe(
                entity => {
                    this.campanha = entity;
                    this.statusCampanha = statusCampanhaSearch ? statusCampanhaSearch : this.campanha.status;
                    this.setConfigAfterLoad(liberarPedidos);
                    setTimeout(() => this.afterLoad(), 0);
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao carregar a campanha', error),
                () => this.isLoading = false
            );
    }

    private loadSemCampanha() {
        this.campanha = createSemCampanha();
        this.loadResultado(this.campanha.id);
        this.setConfig();
        setTimeout(() => this.afterLoad(), 0);
    }

    /** Carrega o resultado da campanha */
    private loadResultado(idCampanha: number){
        this.campanhaResultadoHttpService.load(idCampanha, this.filter)
            .pipe(
                take(1)
            )
            .subscribe(
                resultado => this.campanha.resultado = resultado,
                (error: ApiError) => this.messageService.error(error.message, error.cause, error)
            );
    }

    private afterLoad() {
        // Pesquisando so pedidos não liberados para serem liberados
        if (this.config.isLiberandoPedidos) {
            this.pedidosLiberar.searchPedidos();
            this.pedidosLiberar.setFocusJustificativa();
        }

        // Arquivos
        this.arquivosCardView?.search();
    }

    /** Realizando a liberação dos pedidos */
    async liberarPedidos() {
        const btnLiberar = new ButtonLoader('#btnLiberarPedidos')
        try {
            btnLiberar.loading('Liberando');
            await this.pedidosLiberar.liberar()
            btnLiberar.reset();
            this.close();
            this.afterLiberarPedidos.emit();
        } catch (error) {
            // this.messageService.error('Erro ao tentar liberar o(s) pedido(s). Tente novamente ou entre em contato com o suporte', 'Erro ao liberar', error);
            btnLiberar.reset();
        }
    }

    /** Limpas as variáveis utilizadas no modal */
    private clear() {
        this.campanha = null;
        this.filter = null;
        this.isLoading = false;
    }

    /** Fecha o modal */
    close() {
        this.elModal.modal('hide');
    }

    resize() {
        setTimeout(() => jQuery(window).trigger('resize'), 200);
    }

    onTabResultadoClick() {
        this.resultadoView?.onTabVendasClick();
    }
}
